import React from 'react';

import { withCoachesListContextProvider } from '../CoachesListContext';
import CoachTaskAdminContextProvider from './CoachTaskAdminContextProvider';

/**
 * Inserts CoachTaskAdminContextProvider (and the CoachesListContext it depends on for
 * coach names + the full coach list).
 */
const withCoachTaskAdminContextProvider = (Component) => withCoachesListContextProvider((props) => (
  <CoachTaskAdminContextProvider>
    <Component {...props} />
  </CoachTaskAdminContextProvider>
));

export {
  withCoachTaskAdminContextProvider,
};
